import { render } from "./briefIntroduction.vue?vue&type=template&id=470ee2d6&scoped=true"
import script from "./briefIntroduction.vue?vue&type=script&lang=js"
export * from "./briefIntroduction.vue?vue&type=script&lang=js"

import "./briefIntroduction.vue?vue&type=style&index=0&id=470ee2d6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470ee2d6"]])

export default __exports__